import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { ITblSubmissionStatus } from "../../models/TblSubmissionStatus";
import { safeFormatDate } from "../../models/DateFormatMapper";
import { ILogin } from "../../models/Login";
import { Button } from "primereact/button";

interface Iprops {
    submission_ID: number,
    consultant_Name?: string,
    open: boolean,
    hideDialog: () => void,
    toast: any
}

export const LifeCycle = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ITblSubmissionStatus>, loading: boolean });

    useEffect(() => {
        if (props.submission_ID) loadTableData();
    }, [props.submission_ID]);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Pipeline_Mast/submissionlc", "GET", null, `submission_id=${props.submission_ID}`, props.toast);
        if (response) {
            const data: Array<ITblSubmissionStatus> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const status_Date = (rowData: ITblSubmissionStatus) => {
        let date;
        if (rowData.status_Date) date = format(new Date(rowData.status_Date), 'dd/MM/yyyy hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const onHide = () => {
        props.hideDialog();
        setTableData({ tableData: [], loading: false });
    }
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    const DateFormat = loginObj.date_Format;

    const downloadDoc = async (taskHitoryID: number) => {
        const params = {
            method: "GET",
            headers: {
                "Content-Type": "application/msword",
                Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") + "")?.token}`,
            },
        };
        try {
            const response = await fetch(`${baseUrl}${"Pipeline_Mast/download"}?statusID=${taskHitoryID}`, params);
            if (response.status === 200) {
                const blob = await response.blob();

                const disposition = response.headers.get("content-disposition");
                let fileName = `Rejection_Supportive_Document`;

                if (disposition) {
                    const match = disposition.match(/filename="?([^"]+)"?/);
                    if (match?.[1]) {
                        fileName = match[1];
                    }
                }

                const href = URL.createObjectURL(blob);

                const a = document.createElement("a");
                a.href = href;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                URL.revokeObjectURL(href);
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: "error", detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: "error", detail: "Something went Wrong", life: 3000 });
        }
    };

    const download = (rowData: ITblSubmissionStatus) => {
        return (rowData?.sM_Submission_Rejection_File_Path && rowData?.status_ID) ? (
            <Button
                icon="pi pi-download"
                label=""
                className="p-button-rounded p-button-success p-button-text mr-1"
                onClick={() => {
                    downloadDoc(rowData.status_ID ?? 0);
                }}
            />
        ) : (
            <></>
        );
    };

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={`History found against SubmissionID - ${props.submission_ID} (${props.consultant_Name})`} modal className="p-fluid" onHide={onHide}>
            <DataTable size="small" stripedRows
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="status_Name" header="Status" />
                {/* <Column field="eciDate" header="Date" body={status_Date} /> */}
                <Column field="status_Date" header="Date" body={(rowData: any) => safeFormatDate(rowData.status_Date, 'dd-MM-yyyy', DateFormat, true)} />
                <Column field="comments" header="Comments" />
                <Column field="sM_Submission_Rejection_File_Path" header="File" body={download} />
            </DataTable>
        </Dialog>
    );
}
